module.exports = __webpack_public_path__ + "img/tdf_logo.17fa9178.jpg";